import { render, staticRenderFns } from "./DownloadItem.vue?vue&type=template&id=eabc0394"
import script from "./DownloadItem.vue?vue&type=script&lang=js"
export * from "./DownloadItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports